// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ICustomerAffiliationRoleType {
    id: number;
    customerCategoryType: any;
    value: string;
    displayValue: string;
    description: string;
    isPrimary: boolean;
    sortOrder: number;
    active: boolean;
}

export class CustomerAffiliationRoleType implements ICustomerAffiliationRoleType, IBaseType {
    public id: number;
    public customerCategoryType: any;
    public value: string;
    public displayValue: string;
    public description: string;
    public isPrimary: boolean;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Principal  CustomerAffiliationRoleType
	**/
    get Principal(): ICustomerAffiliationRoleType {
        return this.FromId(1);
    }
    /**
		Returns Agent  CustomerAffiliationRoleType
	**/
    get Agent(): ICustomerAffiliationRoleType {
        return this.FromId(2);
    }
    /**
		Returns Guardian  CustomerAffiliationRoleType
	**/
    get Guardian(): ICustomerAffiliationRoleType {
        return this.FromId(3);
    }
    /**
		Returns Ward CustomerAffiliationRoleType
	**/
    get Ward(): ICustomerAffiliationRoleType {
        return this.FromId(4);
    }
    /**
		Returns President CustomerAffiliationRoleType
	**/
    get President(): ICustomerAffiliationRoleType {
        return this.FromId(5);
    }
    /**
		Returns Vice President  CustomerAffiliationRoleType
	**/
    get VicePresident(): ICustomerAffiliationRoleType {
        return this.FromId(6);
    }
    /**
		Returns Managing Member  CustomerAffiliationRoleType
	**/
    get ManagingMember(): ICustomerAffiliationRoleType {
        return this.FromId(7);
    }
    /**
		Returns Secretary  CustomerAffiliationRoleType
	**/
    get Secretary(): ICustomerAffiliationRoleType {
        return this.FromId(8);
    }
    /**
		Returns Treasurer  CustomerAffiliationRoleType
	**/
    get Treasurer(): ICustomerAffiliationRoleType {
        return this.FromId(9);
    }
    /**
		Returns Admin Assistant Full Access CustomerAffiliationRoleType
	**/
    get AdminAssistantFullAccess(): ICustomerAffiliationRoleType {
        return this.FromId(10);
    }
    /**
		Returns Admin Assistant Read Access CustomerAffiliationRoleType
	**/
    get AdminAssistantReadAccess(): ICustomerAffiliationRoleType {
        return this.FromId(11);
    }
    /**
		Returns Trustee CustomerAffiliationRoleType
	**/
    get Trustee(): ICustomerAffiliationRoleType {
        return this.FromId(12);
    }
    /**
		Returns Grantor  CustomerAffiliationRoleType
	**/
    get Grantor(): ICustomerAffiliationRoleType {
        return this.FromId(13);
    }
    /**
		Returns Beneficiary CustomerAffiliationRoleType
	**/
    get Beneficiary(): ICustomerAffiliationRoleType {
        return this.FromId(14);
    }
    /**
		Returns Organization  CustomerAffiliationRoleType
	**/
    get Organization(): ICustomerAffiliationRoleType {
        return this.FromId(15);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, customerCategoryType: 3, value: 'Principal', displayValue: 'Principal ', description: 'Principal ', isPrimary: true, sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, customerCategoryType: 1, value: 'Agent', displayValue: 'Agent ', description: 'Agent ', isPrimary: false, sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, customerCategoryType: 1, value: 'Guardian', displayValue: 'Guardian ', description: 'Guardian ', isPrimary: true, sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, customerCategoryType: 3, value: 'Ward', displayValue: 'Ward', description: 'Ward', isPrimary: false, sortOrder: 4, active: true });
        this._dictionary.add('5', { id: 5, customerCategoryType: 1, value: 'President', displayValue: 'President', description: 'President', isPrimary: false, sortOrder: 5, active: true });
        this._dictionary.add('6', { id: 6, customerCategoryType: 1, value: 'VicePresident', displayValue: 'Vice President ', description: 'Vice President ', isPrimary: false, sortOrder: 6, active: true });
        this._dictionary.add('7', { id: 7, customerCategoryType: 1, value: 'ManagingMember', displayValue: 'Managing Member ', description: 'Managing Member ', isPrimary: false, sortOrder: 7, active: true });
        this._dictionary.add('8', { id: 8, customerCategoryType: 1, value: 'Secretary', displayValue: 'Secretary ', description: 'Secretary ', isPrimary: false, sortOrder: 8, active: true });
        this._dictionary.add('9', { id: 9, customerCategoryType: 1, value: 'Treasurer', displayValue: 'Treasurer ', description: 'Treasurer ', isPrimary: false, sortOrder: 9, active: true });
        this._dictionary.add('10', { id: 10, customerCategoryType: 1, value: 'AdminAssistantFullAccess', displayValue: 'Admin Assistant Full Access', description: 'Admin Assistant Full Access', isPrimary: false, sortOrder: 10, active: true });
        this._dictionary.add('11', { id: 11, customerCategoryType: 1, value: 'AdminAssistantReadAccess', displayValue: 'Admin Assistant Read Access', description: 'Admin Assistant Read Access', isPrimary: false, sortOrder: 11, active: true });
        this._dictionary.add('12', { id: 12, customerCategoryType: 1, value: 'Trustee', displayValue: 'Trustee', description: 'Views information related to the trust.', isPrimary: false, sortOrder: 12, active: true });
        this._dictionary.add('13', { id: 13, customerCategoryType: 3, value: 'Grantor', displayValue: 'Grantor ', description: 'Performs actions on the vehicle for the trust.', isPrimary: true, sortOrder: 13, active: true });
        this._dictionary.add('14', { id: 14, customerCategoryType: 1, value: 'Beneficiary', displayValue: 'Beneficiary', description: 'A person who is eligible to receive distributions from an estate or a trust.', isPrimary: false, sortOrder: 14, active: true });
        this._dictionary.add('15', { id: 15, customerCategoryType: 2, value: 'Organization', displayValue: 'Organization ', description: 'To map a organization to a business member affiliation bond ', isPrimary: true, sortOrder: 15, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ICustomerAffiliationRoleType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ICustomerAffiliationRoleType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ICustomerAffiliationRoleType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ICustomerAffiliationRoleType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ICustomerAffiliationRoleType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
